/*jshint esversion: 6 */
import {XhrService} from "../../../../layout/frontend/global/newJs/ts/xhr.service";
import {
    addActionClass,
    addErrorClass,
    addLoadingClass,
    addSuccessClass,
    removeLoadingClass
} from "../../../../layout/frontend/global/newJs/js/utilities/updateClasses";
import {appendScriptToDOM} from "../../../../layout/frontend/global/newJs/js/utilities/functions";
import {closeModal, showModal, triggerModal} from "../../../../layout/frontend/global/newJs/js/modal";
import {isTouchDevice} from "../../../../layout/frontend/global/newJs/js/touchDevice";

let favoritesDeleteModalIsInitalized = false;
let favoritesRenameModalIsInitalized = false;
let favoritesCreateModalIsInitalized = false;
function addToFavorites(itemid, beforeSend, successSend, errorSend) {
    const fd = new FormData();
    fd.append("action_id", itemid);

    if (typeof beforeSend !== 'undefined') {
        beforeSend();
    }

    XhrService.generalAjaxCall('add_item_to_favorite', fd, 'POST', 'json').then(res => {
        if (typeof successSend !== 'undefined') {
            successSend(res);
        }
    }, err => {
        console.error(err);
        if (typeof errorSend !== 'undefined') {
            errorSend();
        }
    })
}

function removeFromFavorites(itemid, beforeSend, successSend, errorSend) {
    const fd = new FormData();
    fd.append("action_id", itemid);

    if (typeof beforeSend !== 'undefined') {
        beforeSend();
    }

    XhrService.generalAjaxCall('remove_item_from_favorite', fd).then(res => {
        if (typeof successSend !== 'undefined') {
            successSend(res);
        }
    }, err => {
        console.error(err);
        if (typeof errorSend !== 'undefined') {
            errorSend();
        }
    })
}

function updateFavoritesCount(add = true) {
    for (let count of document.querySelectorAll('.js-favoritesCount')) {
        let value = count.innerHTML;
        if (value == "") {
            value = 0;
        }
        value = parseInt(value);
        if (add) {
            count.innerHTML = value + 1;
        } else {
            if (value > 0) {
                count.innerHTML = value - 1;
            }
        }
        if (parseInt(count.innerHTML) === 0) {
            count.style.display = "none";
        } else {
            addActionClass(count, function () {
                count.style.display = "";
            });
        }
    }
}

function addToFavoriteBtnClasses(el) {

    let icon = el.querySelector('.icon');
    let filledIconClass = 'icon-favorites-filled';
    let emptyIconClass = 'icon-favorites';

    el.classList.remove("js-addToFavorites");
    el.classList.add("js-removeFromFavorites");
    removeLoadingClass(el);
    if (icon) {
        icon.classList.remove(emptyIconClass);
        icon.classList.add(filledIconClass);
    }

}

function removeFromFavoriteBtnClasses(el) {

    let icon = el.querySelector('.icon');
    let filledIconClass = 'icon-favorites-filled';
    let emptyIconClass = 'icon-favorites';

    el.classList.remove("js-removeFromFavorites");
    el.classList.add("js-addToFavorites");

    if (icon) {
        icon.classList.remove(filledIconClass);
        icon.classList.add(emptyIconClass);
    }

}
export function triggerFavoritesBtns() {
    document.addEventListener("click", function (e) {
        let target = e.target;

        if (target.closest(".js-addToFavorites")) {
            let itemID = target.closest(".js-addToFavorites").dataset.id;
            //addLoadingClass(target);
            if (itemID) {

                // Load multifavorites modal
                const elAddToMultifavorites = document.querySelector(".js-addToMultifavorites");
                if(!elAddToMultifavorites) {

                    const fd = new FormData();
                    fd.append("action_favorites", "action_add_modal");

                    XhrService.generalAjaxCall('multifavorites', fd, 'POST', 'json').then(res => {

                        // Add modal to body
                        const modalWrapper = document.createElement("div");
                        modalWrapper.innerHTML = res.html;
                        document.querySelector("body").appendChild(modalWrapper);
                        loadAddItemModal(itemID, true);

                    }, err => {

                    });
                } else {
                    loadAddItemModal(itemID);
                }

            } else {
                console.error("item id not found");
            }
            e.preventDefault();
        }

        if (target.closest(".js-removeFromFavorites")) {
            const itemID = target.dataset.id;
            if (itemID) {
                if (document.body.classList.contains("favorites")) {
                    //addLoadingClass(target);
                    window.location.href = "?action=shop_remove_item_from_favorites&action_id=" + itemID;
                } else {
                    const elAddToMultifavorites = document.querySelector(".js-addToMultifavorites");
                    if(!elAddToMultifavorites) {

                        const fd = new FormData();
                        fd.append("action_favorites", "action_add_modal");

                        XhrService.generalAjaxCall('multifavorites', fd, 'POST', 'json').then(res => {
                            // Add modal to body
                            const modalWrapper = document.createElement("div");
                            modalWrapper.innerHTML = res.html;
                            document.querySelector("body").appendChild(modalWrapper);
                            loadAddItemModal(itemID, false);

                        }, err => {

                        });
                    } else {
                        loadAddItemModal(itemID, false);
                    }
                }
            } else {
                console.error("item id not found");
            }
            e.preventDefault();
        }
    });
}

export function initMultifavorites() {
    triggerFavoritesBtns();
    initMultifavoritesOverview();
    handleItemDelete();
    handleBasketButtons();

    let converterModal = document.querySelector("#favorite_converter_modal");
    if(converterModal) {
        $(converterModal).modal('show');
    }

}

function initMultifavoritesOverview() {
    loadOverviewList();
}

function loadOverviewList() {

    const elOverviewContainer = document.querySelector('.js-multifavorites-overview');
    if(!elOverviewContainer) {
        return;
    }

    elOverviewContainer.classList.add('is-loading');

    // Get create new button
    const elCreateNewButton = document.querySelector(".js-multifavorites-newlist");

    // Clear overview
    elOverviewContainer.innerHTML = '';

    const fd = new FormData();
    fd.append("action_favorites", "action_show_overview");

    XhrService.generalAjaxCall('multifavorites', fd, 'POST', 'json').then(res => {
        elOverviewContainer.innerHTML = elCreateNewButton.outerHTML;
        elOverviewContainer.innerHTML += res.html;


        const elNewFavoriteListModal = document.getElementById("add_new_favourites_list_modal");
        const elEditFavoriteListModal = document.getElementById("edit_favourites_list_modal");
        const elDeleteFavoriteListModal = document.getElementById("delete_favourites_list_modal");

        const actionElements = [
            [".js-multifavorites-newlist", elNewFavoriteListModal, "new"],
            [".js-multifavorites-editlist", elEditFavoriteListModal, "rename"],
            [".js-multifavorites-deletelist", elDeleteFavoriteListModal, "delete"]
        ];

        if (isTouchDevice()) {
          document.body.classList.add('is-touch');
        }

        elOverviewContainer.style.opacity = '1';
        elOverviewContainer.classList.remove('is-loading');

        for(const actionElement of actionElements) {

            document.querySelectorAll(actionElement[0]).forEach((el) => {
                el.addEventListener("click", (e) => {
                    e.preventDefault();

                    // Set basket id
                    const elBasketIdInput = actionElement[1].querySelector(".js-multifavorites-basketid");
                    if(elBasketIdInput) {
                        elBasketIdInput.value = el.dataset.basket;
                    }

                    // Set basket name
                    const elBasketNameInput = actionElement[1].querySelector(".js-multifavorites-basketname");
                    if(elBasketNameInput) {
                        elBasketNameInput.value = el.dataset.name;
                    }

                    // Show modal
                    $(actionElement[1]).modal('show');

                    // Add required functionality
                    switch(actionElement[2]) {
                        case 'new': {
                            createList(actionElement[1]);
                            break;
                        }
                        case 'rename': {
                            renameList(actionElement[1]);
                            break;
                        }
                        case 'delete': {
                            deleteList(actionElement[1]);
                            break;
                        }
                    }

                    e.stopPropagation();
                });
            });

        }

    }, err => {
        console.error(err);
        if (typeof errorSend !== 'undefined') {
            errorSend();
        }
    });

}

function renameList(modal) {

    const elModal = document.querySelector('.js-editFavoriteListModal');
    const elRenameForm = elModal.querySelector("form");
    if(favoritesRenameModalIsInitalized) {
        return;
    }
    favoritesRenameModalIsInitalized = true;
    elRenameForm.addEventListener("submit", (e) => {

        e.preventDefault();


        const fd = new FormData();
        fd.append("action_favorites", "action_rename_list");
        fd.append("rename_favorite_list_name", elRenameForm.querySelector(".js-multifavorites-basketname").value);
        fd.append("basket_ids", elRenameForm.querySelector(".js-multifavorites-basketid").value);

        // Close modal
        $(modal).modal('hide');
        XhrService.generalAjaxCall('multifavorites', fd, 'POST', 'json').then(res => {
        }).then(res => {
            loadOverviewList();
        }, err => {
            console.error(err);
            if (typeof errorSend !== 'undefined') {
                errorSend();
            }
        });

    });

}

function deleteList(modal) {

    const elModal = document.querySelector('.js-deleteFavoriteListModal');
    const elDeleteForm = elModal.querySelector("form");

    if(favoritesDeleteModalIsInitalized) {
        return;
    }

    favoritesDeleteModalIsInitalized = true;

    elDeleteForm.addEventListener("submit", (e) => {

        e.preventDefault();


        const fd = new FormData();
        fd.append("action_favorites", "action_delete_list");
        fd.append("basket_ids", elDeleteForm.querySelector(".js-multifavorites-basketid").value);

        // Close modal
        $(modal).modal('hide');

        XhrService.generalAjaxCall('multifavorites', fd, 'POST', 'json').then(res => {
        }).then(res => {
            loadOverviewList();
        }, err => {
            console.error(err);
            if (typeof errorSend !== 'undefined') {
                errorSend();
            }
        });

    });
}

function createList(modal) {

    const elModal = document.querySelector('.js-createNewFavoriteListModal');
    const elCreateForm = elModal.querySelector("form");

    if(favoritesCreateModalIsInitalized) {
        return;
    }
    favoritesCreateModalIsInitalized = true;
    elCreateForm.addEventListener("submit", (e) => {

        e.preventDefault();

        const fd = new FormData();
        fd.append("action_favorites", "action_new_list");
        fd.append("new_favorite_list_name", document.querySelector(".js-multifavorites-createname").value);

        // Close modal
        $(modal).modal('hide');

        XhrService.generalAjaxCall('multifavorites', fd, 'POST', 'json').then(res => {
        }).then(res => {
            loadOverviewList();
        }, err => {
            console.error(err);
            if (typeof errorSend !== 'undefined') {
                errorSend();
            }
        });

    });
}

function loadAddItemModal(itemID, add = true) {

    // Show modal
    const elModal = document.getElementById("add_item_favourites_list_modal");
    const fd = new FormData();
    let favoriteButton;

    if (add) {
        favoriteButton = document.querySelector(`.js-addToFavorites[data-id="${itemID}"]`);
    } else {
        favoriteButton = document.querySelector(`.js-removeFromFavorites[data-id="${itemID}"]`);
    }

    fd.append("action_favorites", "action_add_modal_list");
    fd.append("item_id", itemID);
    appendConfigurationToFormData(fd);
    elModal.querySelector(".js-multifavorites-listoverview").innerHTML = '';

    addLoadingClass(favoriteButton);

    loadList(elModal, favoriteButton, itemID, fd);

}

function loadList(elModal, favoriteButton, itemID, fd) {

    // Load lists
    XhrService.generalAjaxCall('multifavorites', fd, 'POST', 'json').then(res => {

        // Add list content
        elModal.querySelector(".js-multifavorites-listoverview").innerHTML = res.html;

        const elModalNewListName = elModal.querySelector(".js-multifavorites-newlistname");
        elModalNewListName.style.display = "none";

        document.getElementById("multifavorite_add_item_new").addEventListener("change", (e) => {
            if(document.getElementById("multifavorite_add_item_new").checked) {
                elModalNewListName.style.display = "block";
            } else {
                elModalNewListName.style.display = "none";
            }
        });

        favoriteButton.style.opacity = 0.1;
        removeLoadingClass(favoriteButton);
        $(elModal).modal("show");
        setTimeout(() => {
            favoriteButton.style.opacity = 1;
        }, 2000);

        elModal.querySelectorAll(".js-multifavorites-listoverview input").forEach(el => {
            el.addEventListener("change", (e) => {
                let len = elModal.querySelectorAll("input:checked").length;
                let saveBtn = elModal.querySelector("button.buttonAction");
                if (len === 0) {
                    saveBtn.disabled = true;
                } else {
                    saveBtn.disabled = false;
                }
            });
        })

        const elModalForm = elModal.querySelector("form");
        handleFavoriteFormSubmit(elModalForm, elModal, favoriteButton, itemID);

        let len = elModal.querySelectorAll("input:checked").length;
        let saveBtn = elModal.querySelector("button.buttonAction");
        if (len === 0) {
            saveBtn.disabled = true;
        } else {
            saveBtn.disabled = false;
        }
    }, err => {
        console.error(err);
        if (typeof errorSend !== 'undefined') {
            errorSend();
        }
    });

}

function handleFavoriteFormSubmit(elModalForm, elModal, favoriteButton, itemID) {

    elModalForm.addEventListener("submit", (e) => {
        e.preventDefault();
        console.log("Event", e);

        const submitButton = elModalForm.querySelector('button[type="submit"]');
        submitButton.classList.add('is-loading');
        submitButton.classList.remove('button--action');

        const fd = new FormData();
        fd.append("action_favorites", "action_edit_item");
        fd.append("item_id", itemID);
        fd.append("item_var_code", "");

        // Get basket IDs
        const basketIDList = [];
        elModalForm.querySelectorAll(".js-multifavorites-addlist").forEach(el => {
            if(el.checked) {
                const basketId = el.value;
                if(basketId != "new") {
                    basketIDList.push(basketId);
                    fd.append(basketId, "1");
                }
            }
        });

        const selectedBasketId = basketIDList.join(",");
        const newFavoriteListName = elModalForm.querySelector(".js-multifavorites-newlistname").value;

        fd.append("basket_ids", selectedBasketId);
        fd.append("new_favorite_list_name", newFavoriteListName);

        appendConfigurationToFormData(fd);

        XhrService.generalAjaxCall('multifavorites', fd, 'POST', 'json').then(res => {

            if (itemID.startsWith("basket.")) {
                let targetUrl = "/" + GLOBALS.siteCode + "/" + GLOBALS.languageCode + "/favorites/";
                if (basketIDList.length === 1) {
                    targetUrl += "?list=" + basketIDList[0];
                }
                window.location.assign(targetUrl);
            }

            if (res.itemInList) {
                addSuccessClass(favoriteButton);
                addToFavoriteBtnClasses(favoriteButton);
            } else {
                removeFromFavoriteBtnClasses(favoriteButton);
            }
            updateFavoritesCount(false);

        }, err => {
            console.error(err);
            if (typeof errorSend !== 'undefined') {
                errorSend();
            }
        });

        // Remove modal
        setTimeout(()=> {
            submitButton.classList.remove('is-loading');
            submitButton.classList.add('button--action');
            $(elModal).modal('hide');
            setTimeout(() => $(elModal).parent().remove(), 500);
        },500);



    });

}

function appendConfigurationToFormData(fd) {
    let counter = 1;
    //find line no and quantity for every select
    let selectElements = document.getElementsByClassName('js-select');
    for(let i = 0; i < selectElements.length; i++){
        let selectedOption = selectElements[i].options[selectElements[i].selectedIndex];

        fd.append('input_configuration_bomNo_'+counter, selectedOption.getAttribute('data-bom-no'));
        fd.append('input_configuration_lineNo_'+counter, selectedOption.getAttribute('data-line-no'));

        let quantity = getQuantityForAttribute(selectedOption.parentElement.getAttribute('data-attribute'),false, document);

        quantity = (typeof quantity === 'undefined') ? 1 : quantity;
        fd.append('input_configuration_quantity_'+counter, quantity);
        counter++;
    }

    // add service item to configuration
    var serviceItemSelectElements = document.getElementsByClassName('js-service-select-item-no');
    var serviceItemDurationSelectElements = document.getElementsByClassName('js-service-select-duration');

    if (serviceItemSelectElements.length !== 0 && serviceItemDurationSelectElements.length !== 0) {

        var selectedServiceItemNoOption = serviceItemSelectElements[0].options[serviceItemSelectElements[0].selectedIndex];
        var selectServiceItemNo = selectedServiceItemNoOption.value;

        var selectedServiceItemDurationOption = serviceItemDurationSelectElements[0].options[serviceItemDurationSelectElements[0].selectedIndex];
        var selectServiceItemDuration = selectedServiceItemDurationOption.value;

        fd.append('input_configuration_service_item_no', selectServiceItemNo);
        fd.append('input_configuration_service_duration', selectServiceItemDuration);
    }

    //find line no and quantity for every checkbox
    let checkboxElements = document.getElementsByClassName('js-checkbox');
    for(let i = 0; i < checkboxElements.length; i++){
        let currentAttribute = checkboxElements[i].getAttribute('data-attribute');
        let checkboxOptionElements = document.getElementsByName(currentAttribute+'_checkbox');
        for(let j = 0; j < checkboxOptionElements.length; j++) {
            if(checkboxOptionElements[j].checked){
                fd.append('input_configuration_bomNo_'+counter, checkboxOptionElements[j].getAttribute('data-bom-no'));
                fd.append('input_configuration_lineNo_'+counter, checkboxOptionElements[j].getAttribute('data-line-no'));
                let quantity = getQuantityForAttribute(currentAttribute,false, document);
                quantity = (typeof quantity === 'undefined') ? 1 : quantity;
                fd.append('input_configuration_quantity_'+counter, quantity);
                counter++;
            }
        }
    }

    let disabledElements = document.getElementsByClassName('js-disabled');
    for(let i = 0; i < disabledElements.length; i++){
        console.log(disabledElements[i]);
        let selectedOption = disabledElements[i];

        fd.append('input_configuration_bomNo_'+counter, selectedOption.getAttribute('data-bom-no'));
        fd.append('input_configuration_lineNo_'+counter, selectedOption.getAttribute('data-line-no'));

        let quantity = getQuantityForAttribute(selectedOption.getAttribute('data-attribute'),false, document);

        quantity = (typeof quantity === 'undefined') ? 1 : quantity;
        fd.append('input_configuration_quantity_'+counter, quantity);
        counter++;
    }

    //find line no and quantity for every radio
    let radioElements = document.getElementsByClassName('js-radio');
    for(let i = 0; i < radioElements.length; i++){
        let currentAttribute = radioElements[i].getAttribute('data-attribute');
        let yesRadioInput = document.getElementById(currentAttribute+'_yes');
        if(yesRadioInput.checked) {
            if(!(yesRadioInput.getAttribute('data-line-no') == null)) {
                fd.append('input_configuration_bomNo_'+counter, yesRadioInput.getAttribute('data-bom-no'));
                fd.append('input_configuration_lineNo_'+counter, yesRadioInput.getAttribute('data-line-no'));

                fd.append('input_configuration_quantity_'+counter, 1);
                counter++;
            }
        }
    }
    fd.append('input_configuration_counter', counter-1);
    fd.append('hasConfiguration', counter > 0);
}

function handleItemDelete() {

    document.querySelectorAll(".js-multifavorites-delete").forEach(el => {

        el.addEventListener("click", (e) => {

            const removeItemModal = document.querySelector("#remove_item_favourite_list_modal");

            // Set item id and var code
            removeItemModal.querySelector(".js-multifavorites-item-id").value = el.dataset.id;
            removeItemModal.querySelector(".js-multifavorites-item-var-code").value = el.dataset.varcode;
            removeItemModal.querySelector(".js-multifavorites-item-configuration").value = el.dataset.configuration;

            // Show remove modal
            $(removeItemModal).modal('show');

            e.preventDefault();
        });

    });
}

function handleBasketButtons() {
    document.querySelectorAll(".js-favoritesAddToBasket").forEach(el => {

        el.addEventListener("click", (e) => {

            let form = document.getElementById("form_itemlist");
            let hiddenInput = document.createElement("input");
            hiddenInput.setAttribute('name', 'input_single_favorite');
            hiddenInput.setAttribute('value', el.dataset.id);
            hiddenInput.setAttribute('type', 'hidden');
            form.appendChild(hiddenInput);

            hiddenInput = document.createElement("input");
            hiddenInput.setAttribute('name', 'input_single_favorite_variant');
            hiddenInput.setAttribute('value', el.dataset.varcode);
            hiddenInput.setAttribute('type', 'hidden');
            form.appendChild(hiddenInput);

            hiddenInput = document.createElement("input");
            hiddenInput.setAttribute('name', 'input_single_favorite_configuration');
            hiddenInput.setAttribute('value', el.dataset.configuration);
            hiddenInput.setAttribute('type', 'hidden');
            form.appendChild(hiddenInput);

            form.submit();

        })

    })
}